import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import baseReducer from '../features/base/slice';
import translationReducer from '../features/translation/slice';
// import authReducer from '../features/auth/slice';
// import userReducer from '../features/user/slice';
// import { reducer as OIDCReducer } from 'redux-oidc';
import filterReducer from '../features/filter/slice';
import resultsReducer from '../features/results/slice';

export const store = configureStore({
  reducer: {
    base: baseReducer,
    translations: translationReducer,
    // user: userReducer,
    // auth: authReducer,
    // oidc: OIDCReducer,
    filter: filterReducer,
    results: resultsReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
